export const KlubschuleTheme = {
  name: 'Klubschule Theme',
  themeId: 'klubschule',
  colors: {
    brand: {
      primary: {
        100: '#0053a6'
      },
      secondary: {
        100: '#27333a'
      },
      accent: {
        100: '#0053a6'
      },
      alternative: {
        100: '#27333a'
      }
    }
  },
  fonts: {
    families: {
      text: '"Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      condensed: '"Helvetica Neue Condensed", "Helvetica Neue", "Helvetica", Arial, sans-serif',
      heading: '"Helvetica Neue Condensed", "Helvetica Neue", "Helvetica", Arial, sans-serif',
      subHeading: '"Helvetica Neue Condensed", "Helvetica Neue", "Helvetica", Arial, sans-serif',
      display: '"Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      articleText: '"Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      articleHeading: '"Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif'
    },
    sizes: {
      text: {
        tiny: '10px',
        xsmall: '12px',
        small: '14px',
        medium: '16px',
        large: '18px',
        xlarge: '22px',
        huge: '26px'
      },
      heading: {
        tiny: '14px',
        xsmall: '18px',
        small: '22px',
        medium: '26px',
        large: '32px',
        xlarge: '36px',
        huge: '40px'
      }
    }
  }
};